import React from 'react';
import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import { ICustomTheme } from 'interfaces';

const FilteredUploadDiv: React.FC<{
  isDragOver?: boolean;
  className?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
}> = ({ isDragOver: _, ...rest }) => React.createElement('div', rest);

export const StyledUploadZone = styled(FilteredUploadDiv)(
  ({ theme, isDragOver }: { theme: ICustomTheme; isDragOver?: boolean }) => ({
    border: `2px dashed ${
      isDragOver ? theme.colors.paletteFromBO.main : theme.palette.grey[400]
    }`,
    borderRadius: theme.shape.borderRadius * 2,
    padding: theme.spacing(4),
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: isDragOver
      ? `${theme.colors.paletteFromBO.main}10`
      : theme.palette.grey[50],
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: theme.colors.paletteFromBO.main,
      backgroundColor: `${theme.colors.paletteFromBO.main}10`,
    },
  }),
);

/** Upload icon coloured with the BO primary colour */
export const StyledUploadIcon = styled(CloudUploadIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontSize: 40,
    color: theme.colors.paletteFromBO.main,
  }),
);

/** "Click or drag" prompt text */
export const StyledUploadPromptText = styled(Typography)(() => ({
  marginTop: 8,
}));

/** Caption confirming a file has been selected */
export const StyledUploadSelectedLabel = styled(Typography)(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'block',
    marginTop: 8,
    color: theme.colors.paletteFromBO.main,
    fontWeight: 600,
  }),
);

/** Chip-like bar showing the selected file name + delete action */
export const StyledUploadFileChip = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 8,
    gap: 8,
    backgroundColor: theme.colors.paletteFromBO.main,
    borderRadius: 4,
  }),
);

/** File name text inside the chip */
export const StyledUploadFileName = styled(Typography)(() => ({
  fontWeight: 600,
}));

/** Delete button inside the file chip */
export const StyledUploadDeleteButton = styled('button')(
  ({ theme }: { theme: ICustomTheme }) => ({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    color: theme.colors.error.main,
  }),
);

/** "No file selected" fallback caption */
export const StyledUploadNoneText = styled(Typography)(() => ({
  display: 'block',
  marginTop: 4,
}));

/** Visually-hidden native file input */
export const StyledHiddenFileInput = styled('input')(() => ({
  display: 'none',
}));
